import StepTwo from "@/components/dashboard/depositMoney/StepTwo";

export default function DepositMoneyStepTwo() {
  return <StepTwo />;
}
